import { useEffect, useRef, useState } from 'react';
//
import Scrollbar from '../../../components/Scrollbar';
import Spinner from '../../../components/Spinner';
import useAuth from '../../../hooks/useAuth';
import ChatMessageItem from './ChatMessageItem';

// ----------------------------------------------------------------------

// ChatMessageList.propTypes = {
//   conversation: PropTypes.object.isRequired,
// };

export default function ChatMessageList({ conversation, messages, joiningRoom }) {
  const scrollRef = useRef(null);
  const {user} = useAuth()

  const [openLightbox, setOpenLightbox] = useState(false);

  const [selectedImage, setSelectedImage] = useState(0);

  useEffect(() => {
    const scrollMessagesToBottom = () => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
    };
    scrollMessagesToBottom();
  }, [messages]);

  // const imagesLightbox = messages
  //   .filter((messages) => messages.contentType === 'image')
  //   .map((messages) => messages.body);

  const handleOpenLightbox = (url) => {
    // const selectedImage = imagesLightbox.findIndex((index) => index === url);
    // setOpenLightbox(true);
    // setSelectedImage(selectedImage);
  };

  return (
    <>
      <Scrollbar scrollableNodeProps={{ ref: scrollRef }} sx={{ p: 3, height: 1 }}>
        {messages?.map((message) => (
          <ChatMessageItem
            currentUser={user}
            key={message.id}
            message={message}
            conversation={conversation}
            onOpenLightbox={handleOpenLightbox}
          />
        ))}
        {joiningRoom &&
          <Spinner/>
        }
      </Scrollbar>

      {/* <LightboxModal
        images={imagesLightbox}
        mainSrc={imagesLightbox[selectedImage]}
        photoIndex={selectedImage}
        setPhotoIndex={setSelectedImage}
        isOpen={openLightbox}
        onCloseRequest={() => setOpenLightbox(false)}
      /> */}
    </>
  );
}
